/**
 * Weekly Check-In question definitions.
 * Each question maps to a column in the weekly_checkins table.
 */
export const CHECKIN_QUESTIONS = [
  {
    key: 'feeling_overall',
    question: 'How are you feeling overall?',
    placeholder: "Share how you're doing physically, mentally, emotionally...",
  },
  {
    key: 'daily_todo_accomplished',
    question: 'Were you able to accomplish your to do list? If not what happened?',
    placeholder: 'What went well? Any roadblocks?',
  },
  {
    key: 'nervous_system_tactics',
    question: 'What nervous system tactics did you use this week?',
    placeholder: 'Breathing exercises, meditation, cold exposure, etc.',
  },
  {
    key: 'nutrition_targets',
    question: 'How close were you to your nutrition targets this week?',
    placeholder: 'On track, slightly off, way off — and why?',
  },
  {
    key: 'feeling_nutrition',
    question: 'How are you feeling about nutrition?',
    placeholder: 'Confident, struggling, motivated, overwhelmed...',
  },
  {
    key: 'food_journal_sent',
    question: 'Did you upload your food journal?',
    placeholder: 'Yes / No — any notes?',
  },
  {
    key: 'average_step_count',
    question: 'What was your average step count this week?',
    placeholder: 'e.g. 8,500 steps/day',
  },
  {
    key: 'additional_exercise',
    question: 'Did you do any other additional exercise?',
    placeholder: 'Gym, running, yoga, sports, etc.',
  },
  {
    key: 'average_weight',
    question: 'What was your average weight this week?',
    placeholder: 'e.g. 165 lbs',
  },
  {
    key: 'wins',
    question: 'Wins over the last week? Even small wins.',
    placeholder: 'Celebrate your progress, no matter how small!',
  },
  {
    key: 'working_on',
    question: 'Things you are working on?',
    placeholder: 'Habits, mindset shifts, specific goals...',
  },
  {
    key: 'discoveries',
    question: 'Discoveries you have made this week?',
    placeholder: 'New insights about yourself, your body, routines...',
  },
  {
    key: 'goals_next_week',
    question: 'What are your goals for next week? Get specific.',
    placeholder: 'Be as detailed as possible — what, when, how...',
  },
];

/**
 * Get the Monday of the current week (used as week_of identifier).
 */
export function getCurrentWeekMonday() {
  const now = new Date();
  const day = now.getDay(); // 0=Sun, 1=Mon...
  const diff = day === 0 ? 6 : day - 1; // If Sunday, go back 6 days
  const monday = new Date(now);
  monday.setDate(now.getDate() - diff);
  return monday.toISOString().split('T')[0];
}

/**
 * Format a week_of date for display.
 */
export function formatWeekLabel(weekOf) {
  const monday = new Date(weekOf + 'T12:00:00');
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const opts = { month: 'short', day: 'numeric' };
  return `${monday.toLocaleDateString('en-US', opts)} – ${sunday.toLocaleDateString('en-US', opts)}`;
}
